<template lang="pug">
div#main
  card-credenciado(
    :cardTitle="isEdicao ? `Edição de credenciado ${tipoCadastro.toLowerCase()}` : `Cadastro de credenciado ${tipoCadastro.toLowerCase()}`"
    showBtnAction=false
  )
    template(slot="body")
      validation-observer(ref='observer', tag='form', v-slot="{ handleSubmit }")
        form(@submit.prevent="onSubmit")
          divider.margin-bottom-20(label="Dados pessoais")
          el-row.margin-bottom-20(type="flex", :gutter="40")
            el-col(:lg="12")
              validation-provider(
                ref="cpf",
                :rules="{required: true, cpf: true}",
                v-slot="{ errors }",
                name="cpf"
              )
                Label(label="CPF:", :required="true")
                el-input.input(
                  v-model="credenciado.pessoa.pessoaFisica.cpf",
                  v-mask="['###.###.###-##']"
                )
                span.error {{ errors[0] }}
            el-col(:lg="12")
              validation-provider(
                ref="nome",
                :rules="{required: true}",
                v-slot="{ errors }",
                name="nome"
              )
                Label(label="Nome:", :required="true")
                el-input.input(
                  v-model="credenciado.pessoa.pessoaFisica.nome",
                )
                span.error {{ errors[0] }}
          el-row.margin-bottom-20(type="flex", :gutter="40")
            el-col(:lg="12")
              validation-provider(
                ref="email",
                :rules="{required: true, email: true}",
                v-slot="{ errors }",
                name="email"
              )
                Label(label="E-mail:", :required="true")
                el-input.input(
                  v-model="credenciado.pessoa.email",
                )
                span.error {{ errors[0] }}
            el-col(:lg="12")
              validation-provider(
                ref="e-mail",
                rules="required|email|confirmed:email",
                v-slot="{ errors }",
                name="e-mail"
              )
                Label(label="Confirmar e-mail:", :required="true")
                el-input.input(
                  v-model="confirmarEmail",
                )
                span.error {{ errors[0] }}
          el-row.margin-bottom-20(type="flex", :gutter="40")
            el-col(:lg="12")
              validation-provider(
                ref="telefones",
                v-slot="{ errors }",
                name="telefones"
              )
                Label(label="Telefone(s):", :required="true")
                el-input.input(
                  label='Telefone',
                  v-mask="['(##) #####-####', '(##) ####-####']",
                  v-model="fone"
                  :placeholder="numeroTelefone > 2 ? 'Máximo de 3 telefones' : ''"
                  :disabled="numeroTelefone > 2"
                )
                  el-button.style(
                    slot="append",
                    icon="el-icon-plus",
                    @click="addTelefone(fone)",
                    :disabled="fone.length < 14",
                  )
                div.tag-app-input.marginTop
                  el-tag(
                    v-for="(telefone, index) in numeroTelefone",
                    :key="index",
                    closable,
                    type="info",
                    size="medium",
                    @close="removeTelefone(telefone)"
                  ) {{ telefone }}
                span.error(v-if='validaCampoTelefone') O campo é obrigatório
          divider.margin-bottom-20(label="Dados do credenciado")
          el-row.margin-bottom-20(type="flex", :gutter="40")
            el-col(:lg="12")
              validation-provider(
                ref="codigoCrea",
                :rules="{required: true}",
                v-slot="{ errors }",
                name="codigoCrea"
              )
                Label(label="Registro no conselho:", :required="true")
                el-input.input( v-model="credenciado.codigoCrea")
                span.error {{ errors[0] }}
            el-col(:lg="12" v-if="tipoCadastro === 'GEOMENSOR'")
              validation-provider(
                ref="codigoIncra",
                :rules="{required: true}",
                v-slot="{ errors }",
                name="codigoIncra"
              )
                  Label(label="Código de credenciamento no INCRA:", :required="true")
                  el-input.input(
                    v-model="credenciado.codigoIncra",
                    maxlength="4",
                    minlength="3",
                    show-word-limit,
                  )
                  span.error {{ errors[0] }}
            el-col(:lg="12" v-else)
              include commons/inputFormacaoVistoriador.pug

          el-row.margin-bottom-20(type="flex", :gutter="40" v-if="tipoCadastro === 'GEOMENSOR'")
            el-col(:lg="12")
              include commons/inputFormacaoGeomensor.pug

          divider.margin-bottom-20(label="Endereço")
          el-row.margin-bottom-20(type="flex", :gutter="40")
            el-col(:lg="12")
              validation-provider(
                ref="logradouro",
                :rules="{required: true}",
                v-slot="{ errors }",
                name="logradouro"
              )
                Label(label="Logradouro:", :required="true")
                el-input.input(
                  v-model="credenciado.pessoa.endereco.logradouro",
                  show-word-limit,
                  maxlength="100",
                )
                span.error {{ errors[0] }}

            el-col(:lg="12")
              validation-provider(
                ref="numero",
                :rules="{required: !credenciado.pessoa.endereco.numero && !credenciado.pessoa.endereco.semNumero }",
                v-slot="{ errors }",
                name="numero"
              )
                Label(label="Número:", :required="true")
                el-input.input(
                  v-model="credenciado.pessoa.endereco.numero",
                  :disabled="credenciado.pessoa.endereco.semNumero"
                  type="number"
                )
                  el-checkbox.input(
                    v-model="credenciado.pessoa.endereco.semNumero",
                    label="S/N", slot="prepend",
                    @change="onSemNumeroCheck"
                  )
                span.error {{ errors[0] }}

          el-row.margin-bottom-20(type="flex", :gutter="40")
            el-col(:lg="12")
              Label(label="Complemento:", :required="false")
              el-input.input(v-model="credenciado.pessoa.endereco.complemento")

            el-col(:lg="12")
              validation-provider(
                ref="Bairro",
                :rules="{required: true }",
                v-slot="{ errors }",
                name="Bairro"
              )
                Label(label="Bairro:", :required="true")
                el-input.input(
                  v-model="credenciado.pessoa.endereco.bairro",
                )
                span.error {{ errors[0] }}
          el-row.margin-bottom-20(type="flex", :gutter="40")
            el-col(:lg="12")
              validation-provider(
                ref="cep",
                :rules="{required: true, cep: true }",
                v-slot="{ errors }",
                name="cep"
              )
                Label(label="CEP:", :required="true")
                el-input.input(
                  v-model="credenciado.pessoa.endereco.cep",
                  v-mask="'#####-###'",
                )
                span.error {{ errors[0] }}

            el-col(:lg="12")
              validation-provider(
                ref="uf",
                :rules="{required: true }",
                v-slot="{ errors }",
                name="uf"
              )
                Label(label="UF:", :required="true")
                el-select.select.input(
                  v-model="credenciado.pessoa.endereco.uf",
                  filterable
                  @change="changeUf"
                )
                  el-option(
                    v-for="item in estados"
                    :key="item"
                    :label="item"
                    :value="item"
                  )
                span.error {{ errors[0] }}

            el-col(:lg="12")
              validation-provider(
                ref="municipio",
                :rules="{required: true }",
                v-slot="{ errors }",
                name="municipio"
              )
                Label(label="Município:", :required="true")
                el-select.select.input(
                  v-model="credenciado.pessoa.endereco.municipio.nome",
                  @change="(value) => handleChangeMunicipio(value)",
                  filterable,
                  placeholder="Selecione",
                  remote,
                  :remote-method="searchMunicipio",
                  @focus="handleMunicipios(ufSolicitacao)",
                  :disabled="!credenciado.pessoa.endereco.uf",
                )
                  el-option(
                    v-for="item in listMunicipios"
                    :key="item.id"
                    :label="item.nome"
                    :value="item.nome"
                  )
                span.error {{ errors[0] }}
          app-documentos(
            :documentos="credenciado.documentos",
            :tiposDocumentos="tiposDocumentos.tipos",
            :tiposDocumentosObrigatorios="tiposDocumentos.obrigatorios",
            :url="url",
            aba="Credenciado"
            :mensagensTipoDocumento="mensagensTipoDocumento"
            :maxSize='20'
            @addDoc="adicionaDoc"
            @removeDoc="removeDoc"
            @tipoDocumentoOnChange="changeTipoDocumentoAtivo"
            :validExtensions="extensoesDocumentoAtivo"
          )
          el-row.margin-top.footer(type="flex", justify="start")
            el-button(
              @click="cancelar"
              class="cancel"
            )
              i.fas.fa-times
              |  Cancelar
            el-button(type="primary", @click="confirmarTermos")
              i.fas.fa-check
              |  {{!isEdicao ? 'Cadastrar' : 'Salvar'}}

  modal-termos(
    :tipoCadastro="tipoCadastro"
    :modal-open="visualizarTermos"
    @close-modal="visualizarTermos = false"
    @confirmar="cadastrar"
  )

</template>

<script>
import CardCredenciado from '@/screens/credenciados/components/CardCredenciado.vue'
import { Label, Divider } from 'sicarf-components'
import AppDocumentos from '@/components/AppDocumentos'
import ModalTermos from '@/components/modalTermoCompromisso'
import cadastroCredenciadoMixin from '@/screens/credenciados/cadastroCredenciadoMixin'

export default {
  mixins: [cadastroCredenciadoMixin],
  components: {
    CardCredenciado,
    Label,
    Divider,
    AppDocumentos,
    ModalTermos
  },

  props: ['observer'],

  async mounted () {
    await this.initCadastro()

    if (this.credenciado.pessoa.endereco.uf) {
      await this.handleMunicipios(this.credenciado.pessoa.endereco.uf)
    }
  }
}
</script>

<style lang="scss">
.card-header {
  margin-bottom: 20px;
}
.footer {
  place-content: space-between;
  margin-top: 40px;
}
.select {
  width:100%
}

.marginTop {
  margin-top: 5px;
}

.tag-app-input i{
  color: #9BA0A9 !important;
}

.tag-app-input i:hover {
  color: #F7F7F8 !important;
  background-color: #878D99 !important;
}

.el-tag {
  margin-left: 0;
  margin-right: 5px;
  margin-bottom: 5px;
  background-color: #f3f4f5;
  border-color: #dddfe2;
  color: #9ba0a9 ;
}
.style {
  color: #9ba0a9 !important;
}

.margin-bottom-20 {
  margin-bottom: 20px;
}

.margin-top-50 {
  margin-top: 50px;
}

.container-cadastro {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.el-icon-search {
  color: #009f61;
}

span::v-deep .el-input__count-inner {
  color:#009f61
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance:textfield;
}

.cancel:hover, .cancel:focus {
  background-color:#fef0f0;
  color: #f56c6c;
  border-color: #fbc4c4;
}
</style>
